@if (isCopyable) {
<span
  class="support-id"
  role="button"
  tabindex="0"
  [ngbTooltip]="tooltip"
  tooltipClass="custom-tooltip"
  [appCopyToClipboard]="displayValue"
  [copySuccessMessage]="label + ' copiado al portapapeles'"
  (click)="stopPropagation($event)"
>
  <span class="support-id__label">{{ label }}</span>
  <span class="support-id__value">{{ displayValue }}</span>
  <i class="fa-regular fa-copy support-id__icon" aria-hidden="true"></i>
</span>
} @else {
<span class="support-id support-id--empty" [ngbTooltip]="tooltip" tooltipClass="custom-tooltip">
  <span class="support-id__value">{{ displayValue }}</span>
</span>
}
